import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    path: '',
    redirect: '/order',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: {
      title: '大苑子-登入',
    },
  },
  {
    path: '/guest',
    name: 'guest',
    component: () => import('../views/Guest.vue'),
    meta: {
      title: '大苑子',
    },
  },
  {
    path: '',
    name: 'pos',
    component: () => import('../views/Wrapper.vue'),
    children: [
      {
        path: '/order',
        name: 'order',
        component: () => import('../views/Order.vue'),
        meta: {
          title: '點餐',
        },
      },
      {
        path: '/checkout',
        name: 'checkout',
        component: () => import('../views/Checkout.vue'),
        meta: {
          title: '結帳',
        },
      },
    ],
  },
];

const DEFAULT_TITLE = '雲端POS系統';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isLogin = sessionStorage.getItem('session');
  if (isLogin) {
    if (to.path === '/login') next('/');
    else next();
  } else {
    if (to.path !== '/login' && to.path !== '/guest') next('/login');
    else next();
  }
  document.title = to.meta.title || DEFAULT_TITLE;
});

export default router;
